<div class="custom-component-wrapper" [style]="wrapperStyle()">
  <div
    class="custom-component-container"
    [style]="containerStyle()"
    [class.has-fixed-width]="hasFixedWidth()"
    [class.has-border]="hasBorder()"
  >
    <!-- Component preview -->
    <div class="custom-component-preview" [class.has-fixed-height]="height() !== null && height() !== undefined">
      @if (!resolvedComponent()) {
        <div class="custom-component-placeholder">
          @if (componentId()) {
            <span class="custom-component-error">Component not found: {{ componentId() }}</span>
          } @else {
            <span>No component selected. Click the pencil to configure.</span>
          }
        </div>
      }
      <ng-container #componentHost></ng-container>
    </div>

    <!-- Edit button (pencil icon, shown on hover) -->
    @if (editor().isEditable) {
      <button class="edit-btn" (click)="openSettings()" title="Edit custom component settings">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
        </svg>
      </button>
    }

    <!-- Resize handles -->
    @if (editor().isEditable) {
      <div class="resize-handle resize-handle-right" (mousedown)="onWidthResizeStart($event)"></div>
      <div class="resize-handle resize-handle-bottom" (mousedown)="onHeightResizeStart($event)"></div>
    }
  </div>
</div>

<!-- Settings modal -->
<ion-modal [isOpen]="showSettings()" [backdropDismiss]="true" (didDismiss)="closeSettings()">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Custom Component Settings</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <div class="settings-content">
        <!-- Layout section -->
        <div class="settings-section">
          <h4 class="settings-section-title">Layout</h4>

          <div class="settings-row">
            <dojo-number-input
              label="Width (px)"
              [formCtrl]="widthCtrl"
              placeholder="Auto (100%)"
              [min]="100"
              (blur)="applyWidth()"
            />
          </div>

          <div class="settings-row">
            <dojo-number-input
              label="Height (px)"
              [formCtrl]="heightCtrl"
              placeholder="Auto"
              [min]="50"
              (blur)="applyHeight()"
            />
          </div>

          <div class="settings-row">
            <dojo-number-input
              label="Padding (px)"
              [formCtrl]="paddingCtrl"
              placeholder="0"
              [min]="0"
              [step]="4"
              (blur)="applyPadding()"
            />
          </div>

          <!-- Alignment (only when width is set) -->
          @if (hasFixedWidth()) {
            <div class="settings-row">
              <label class="settings-label">Alignment</label>
              <div class="align-buttons">
                <button
                  class="align-btn"
                  [class.active]="align() !== 'center' && align() !== 'right'"
                  (click)="setAlign('left')"
                >
                  Left
                </button>
                <button class="align-btn" [class.active]="align() === 'center'" (click)="setAlign('center')">
                  Center
                </button>
                <button class="align-btn" [class.active]="align() === 'right'" (click)="setAlign('right')">
                  Right
                </button>
              </div>
            </div>
          }
        </div>

        <!-- Appearance section -->
        <div class="settings-section">
          <h4 class="settings-section-title">Appearance</h4>

          <div class="settings-row toggle-row">
            <span class="settings-label">Show border</span>
            <ion-toggle [checked]="hasBorder()" (ionChange)="toggleBorder($any($event).detail.checked)" />
          </div>
        </div>

        <!-- Component config section -->
        <div class="settings-section">
          <h4 class="settings-section-title">Component Config</h4>

          <textarea
            class="config-textarea"
            [ngModel]="configJson()"
            (ngModelChange)="onConfigChange($event)"
            spellcheck="false"
            placeholder='{ "component_id": "...", "preset": "...", "inputs": { ... } }'
          ></textarea>

          @if (jsonError(); as error) {
            <div class="config-error">{{ error }}</div>
          }

          @if (availablePresets().length) {
            <div class="config-presets-hint">Available presets: {{ availablePresets().join(', ') }}</div>
          }
        </div>
      </div>
    </ion-content>

    <ion-footer class="settings-footer">
      <div class="settings-footer-inner">
        <dojo-button fill="outline" (click)="closeSettings()">Done</dojo-button>
      </div>
    </ion-footer>
  </ng-template>
</ion-modal>
